<template>
    <div :class="` animated ${showServiceForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`">
        <FormSection :application-id="application" :showBackground="false">
            <template v-if="isLoading" #content>
                <div class="p-5 d-flex flex-column text-center text-primary">
                    <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                    <div class="big-text mt-1">
                        <b>Save Service Location In Progress...</b>
                    </div>
                </div>
            </template>
            <template v-else #content>
                <div class="p-3 col-12 row">
                    <div class="form-group col-12 col-lg-3">
                        <label for="service_location">
                            Service Location
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <select
                            id="Referral_Service_Location"
                            name="service_location"
                            class="form-select"
                            v-model="service.Code"
                        >
                            <option :value="null">Select Location</option>
                            <option v-for="[key, value] of ServiceLocations" :key="key" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-3 pe-lg-2">
                        <label for="DOB"> Date </label>
                        <DatePicker :getDate="onDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="DOB"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    autocomplete="off"
                                    :value="formatDateInput(service.Start)"
                                    date-format-only
                                    @change="onDateInputChange"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>
                    <div class="form-group col-12 col-lg-3 pe-lg-2">
                        <label for="DOB"> Time </label>
                        <TimePicker class="flex-fill ms-1" @update-props="changeStartTime">
                            <input
                                id="travel-start-time"
                                type="text"
                                class="form-control"
                                autocomplete="off"
                                :maxlength="8"
                                :value="service.StartTime"
                            />
                        </TimePicker>
                    </div>
                    <div class="form-group col-12 col-lg-3 pe-lg-2 mt-4">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="handleSave()">Save</button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="handleCancel()">
                            Cancel
                        </button>
                    </div>
                </div>
            </template>
        </FormSection>
    </div>
</template>

<script src="./AddServiceLocationForm.ts"></script>
